var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("v-card-title", [_vm._v("Energy Prices")]),
      _c(
        "v-card-text",
        [
          _c("v-textarea", {
            attrs: { outlined: "" },
            model: {
              value: _vm.computedValue,
              callback: function ($$v) {
                _vm.computedValue = $$v
              },
              expression: "computedValue",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }